
export const getLocalizedDate = (locale, date, dateStyle = 'full') => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  if (date instanceof Date) {
    return new Intl.DateTimeFormat(locale, { dateStyle }).format(date);
  }
  return '';
}

export const getLocalizedDay = (locale, date, dayStyle = 'full') => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  if (date instanceof Date) {
    return new Intl.DateTimeFormat(locale, { weekday: dayStyle }).format(date);
  }
  return '';
}

export const getLocalizedTime = (locale, date, timeStyle = 'short') => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  if (date instanceof Date) {
    return new Intl.DateTimeFormat(locale, { timeStyle }).format(date);
  }
  return '';
}

export const getLocalizedDateTime = (locale, date, dateStyle = 'full', timeStyle = 'short') => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  if (date instanceof Date) {
    return new Intl.DateTimeFormat(locale, { dateStyle, timeStyle }).format(date);
  }
  return '';
}

export const fetchResource = (resource, payload, draft) => {
  if (Array.isArray(payload)) {
    payload.forEach(record => {
      draft[resource].byId[record.id] = record;
      draft[resource].allIds.push(record.id);
    });
  } else {
    draft[resource].byId[payload.id] = payload;
    draft[resource].allIds.push(payload.id);
  }

  draft[resource].allIds = draft[resource].allIds.filter((value, index, self) => {
    return self.indexOf(value) === index;
  })
  .sort((a, b) => a - b);
}

// helper to diagnose what's causing a component to re-render.
// call from shouldComponentUpdate
export const getComponentDiff = (oldProps, newProps, oldState, newState) => {
  const diff = (oldObj, newObj) => {
    let diffObj = {}
    for (let key in newObj) {
      if (oldObj[key] !== newObj[key]) {
        diffObj[key] = newObj[key];
      }
    }
    return diffObj;
  }

  return {
    props: diff(oldProps, newProps),
    state: diff(oldState, newState)
  }
}
export const getMonth = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  return months[date.getMonth()];
}

export const getMonthAbbr = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  return months[date.getMonth()];
}

export const getDay = (date, format = 'long') => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  let day = days[date.getDay()];
  if (format === 'short') {
    day = day.substring(0, 3);
  }

  return day
}

export const formatDate = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let month = getMonth(date);
  let day = date.getDate();
  let year = date.getFullYear();

  return `${month} ${day}, ${year}`;
}

export const formatShortDate = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let year = date.getFullYear();

  let month = date.getMonth() + 1;
  if (month.toString().length === 1) {
    month = '0' + month;
  }

  let day = date.getDate();
  if (day.toString().length === 1) {
    day = '0' + day;
  }

  return `${year}-${month}-${day}`;
}

export const randomString = n => {
  n = n || 36;
  return Math.random().toString(n).substring(7);
}
